import type { CoupleSpace, Ticket } from './types';

export interface LocalStats {
  rewards: number;
  penalties: number;
  completed: number;
  topTags: Array<{ label: string; count: number }>;
  anniversaryDays: number | null;
}

export function calculateStats(tickets: Ticket[], now: string, anniversary: CoupleSpace['anniversary']): LocalStats {
  const tagCounts = new Map<string, number>();
  let rewards = 0;
  let penalties = 0;
  let completed = 0;

  for (const ticket of tickets) {
    if (ticket.type === 'reward') rewards += 1;
    else penalties += 1;
    if (ticket.state === 'completed') completed += 1;
    for (const tag of ticket.tags) tagCounts.set(tag, (tagCounts.get(tag) ?? 0) + 1);
  }

  return {
    rewards,
    penalties,
    completed,
    topTags: [...tagCounts.entries()]
      .map(([label, count]) => ({ label, count }))
      .sort((left, right) => right.count - left.count || left.label.localeCompare(right.label, 'zh-CN')),
    anniversaryDays: anniversary ? calendarDaysBetween(anniversary, now) : null,
  };
}

function calendarDaysBetween(start: string, end: string): number {
  const startDate = parseCalendarDate(start);
  const endDate = parseCalendarDate(end);
  return (Date.UTC(endDate.year, endDate.month - 1, endDate.day) - Date.UTC(startDate.year, startDate.month - 1, startDate.day)) / 86_400_000;
}

function parseCalendarDate(value: string): { year: number; month: number; day: number } {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
  if (!match) throw new Error('invalid calendar date');
  const [, yearText, monthText, dayText] = match;
  const year = Number(yearText);
  const month = Number(monthText);
  const day = Number(dayText);
  const date = new Date(year, month - 1, day);
  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
    throw new Error('invalid calendar date');
  }
  return { year, month, day };
}
